<template>
  <div @click="hideMenu">
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <button style="float: left; margin-top: -5px" type="button" class="btn btn-tool" data-toggle="collapse" href="#collapse1">
          <i class="fas fa-minus"></i>
        </button>
        <h5 class="card-title" id="accordion">Filtrar cadastros</h5>
      </div>
      <!--<div id="collapse1" class="collapse" data-parent="#accordion"> -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Id</label>
              <input class="form-control" v-model="id" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_estado">UF</label>

              <select
                class="custom-select rounded-0"
                id="endereco_estado"
                v-model="estado"
                @change="buscarCidades()"
                style="text-transform: uppercase"
              >
                <option value=""></option>
                <option v-for="estado in estados" :key="estado" :value="estado.id">
                  {{ estado.nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_cidade">Cidade</label>

              <select class="custom-select rounded-0" id="endereco_cidade" v-model="cidade" style="text-transform: uppercase">
                <option value=""></option>
                <option v-for="cidade in cidades" :key="cidade" :value="cidade.id">
                  {{ cidade.nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="tipo">PF/PJ</label>

              <select class="custom-select rounded-0" id="tipo" v-model="cadastro_tipo" style="text-transform: uppercase">
                <option value=""></option>
                <option value="pf">PF</option>
                <option value="pj">PJ</option>
              </select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Celular</label>
              <input class="form-control" id="descricao" v-model="telefone" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">CPF</label>
              <input class="form-control" id="descricao" v-model="cpf" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">CNPJ</label>
              <input class="form-control" id="descricao" v-model="cnpj" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Email</label>
              <input class="form-control" id="descricao" v-model="email" style="text-transform: lowercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Apelido</label>
              <input class="form-control" id="descricao" v-model="apelido" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="estado_civil">Total de habilitações</label>

              <select class="custom-select rounded-0" id="estado_civil" v-model="estado_civil">
                <option :value="0">0</option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="estado_civil">Status</label>
              <select class="custom-select rounded-0" v-model="status_usuario" style="text-transform: uppercase">
                <option value=""></option>
                <option value="aguardando_docs">Aguardando_docs</option>
                <option value="aguardando_liberacao">Aguardando_liberacao</option>
                <option value="bloqueado">Bloqueado</option>
                <option value="incompleto">Incompleto</option>
                <option value="liberado">Liberado</option>
                <option value="pendente">Pendente</option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Nome</label>
              <input class="form-control" id="descricao" v-model="nome" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Endereço</label>
              <input class="form-control" id="endereco" v-model="endereco" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Somente magistrados</label>

              <input
                class="form-control"
                @change="buscarUsuarios"
                style="height: 25px; width: 25px; position: absolute; margin-top: 5px"
                v-model="somente_magistrados"
                type="checkbox"
              />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="cpf_cnpj">Razão social</label>
              <input class="form-control" id="descricao" v-model="razao_social" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="telefone_fixo">Fone</label>
              <input class="form-control" id="descricao" v-model="telefone_fixo" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarUsuarios()">Buscar</button>

              <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 15px">Limpar filtros</button>
            </div>
          </div>
        </div>
        <!--  </div> -->
      </div>
    </div>

    <!-- TABELA DE LEILÕES -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Cadastros</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>ID</th>
              <th>Detalhes</th>
              <th>Endereço</th>
              <th>Contato</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(user, index) in users"
              :key="user"
              :style="getStyle(user)"
              :class="getClass(user)"
              @contextmenu.prevent="onRightClick($event, user)"
            >
              <td data-label="Seq">
                {{ index + 1 }}
              </td>
              <td data-label="Id">&nbsp;#{{ user.user_id }}&nbsp;</td>

              <td data-label="Detalhes">
                <strong>Apelido:</strong>
                &nbsp;
                <i class="fa-solid fa-circle" style="margin-right: 3px" :style="getStyleOnline(user)"></i>

                <a :href="'/admin/cadastros/detalhes/' + user.user_id" style="text-transform: uppercase">{{ user.apelido }}</a>
                <span
                  class="right badge badge-danger"
                  style="margin-left: 15px; background-color: blue"
                  v-if="user.cadastro_tipo == 'pf' && user.magistrado == 1"
                >
                  PF-MAGISTRADO
                </span>
                <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904" v-else-if="user.cadastro_tipo == 'pj'">
                  PJ
                </span>
                <span class="right badge badge-danger" style="margin-left: 15px; background-color: blue" v-else-if="user.cadastro_tipo == 'pf'">
                  PF
                </span>
                <span
                  class="right badge"
                  style="margin-left: 3px; background-color: #9c362d; color: white"
                  v-if="user.telefone_celular_verificado == 0"
                >
                  SMS NÃO VALIDADO
                </span>
                <span class="right badge" style="margin-left: 3px; background-color: #c24236; color: white" v-if="!user.email_verified_at">
                  E-MAIL NÃO VALIDADO
                </span>
                <br />

                <strong>Nome:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.nome_completo }}</a>

                <div v-if="user.cadastro_tipo == 'pj'">
                  <b>CNPJ:&nbsp;</b>
                  <span>{{ user.pj_cnpj }}</span>
                </div>

                <div v-if="user.cadastro_tipo == 'pj'">
                  <b>Razão social:&nbsp;</b>
                  <span>{{ user.pj_razao_social }}</span>
                </div>

                <br />
                <strong>Estado civil:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.estado_civil }}</a>
                <br />
                <strong>CPF:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ formatarCPF(user.cpf) }}</a>
                <span
                  @click="cadastro_selecionado = user"
                  data-toggle="modal"
                  data-target="#visualizar-cpfs"
                  class="right badge badge-danger"
                  style="margin-left: 15px; background-color: blue"
                  v-if="user.cpfs && user.cpfs.length > 0"
                >
                  Existe
                </span>
                <br />
                <strong>RG:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.rg }}</a>
                <br />
                <br />
                <strong>Data do cadastro:</strong>
                &nbsp;
                <span v-if="user.created_at">{{ formatDate(user.created_at) }} (há {{ calcularValor(user.created_at) }})</span>
                <br />
                <strong>Status:</strong>

                <span class="right badge badge-success" style="margin-left: 5px" v-if="user.status == 'liberado'">LIBERADO</span>
                <span class="right badge badge-danger" style="margin-left: 5px; background-color: #dbb50a" v-else-if="user.status == 'pendente'">
                  PENDENTE
                </span>
                <span class="right badge badge-danger" style="margin-left: 5px" v-else-if="user.status == 'bloqueado'">BLOQUEADO</span>
                <span class="right badge badge-danger" style="text-transform: uppercase; margin-left: 5px; background-color: gray" v-else>
                  {{ user.status }}
                </span>
              </td>

              <td data-label="Endereço">
                <strong>Endereço:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.endereco }}</a>
                <br />
                <strong>Número:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.endereco_num }}</a>
                <br />
                <strong>Complemento:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.endereco_complemento }}</a>
                <br />
                <strong>Bairro:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.endereco_bairro }}</a>
                <br />
                <strong>CEP:</strong>
                &nbsp;
                <a style="text-transform: uppercase">{{ user.endereco_cep }}</a>
                <br />
                <strong>Cidade/UF:</strong>
                &nbsp;
                <a style="text-transform: uppercase" v-if="user.cidade && user.estado">{{ user.cidade + "/" + user.estado }}</a>
                <br />
                <br />
                <div v-if="user.cadastro_tipo == 'pj'">
                  <b>Endereço da empresa:</b>

                  <div>
                    <b>Endereço:&nbsp;</b>
                    <span>{{ user.pj_endereco }}</span>
                  </div>

                  <div>
                    <b>Número:&nbsp;</b>
                    <span>{{ user.pj_endereco_num }}</span>
                  </div>

                  <div>
                    <b>Complemento:&nbsp;</b>
                    <span>{{ user.pj_endereco_complemento }}</span>
                  </div>

                  <div>
                    <b>Bairro:&nbsp;</b>
                    <span>{{ user.pj_endereco_bairro }}</span>
                  </div>

                  <div>
                    <b>CEP:&nbsp;</b>
                    <span>{{ user.pj_endereco_cep }}</span>
                  </div>

                  <div>
                    <b>Cidade/UF:&nbsp;</b>
                    <span v-if="user.cidade && user.estado">{{ user.pj_cidade + "/" + user.pj_estado }}</span>
                  </div>
                </div>
              </td>

              <td data-label="Contato">
                <strong>E-mail:</strong>
                &nbsp;{{ user.email }}
                <br />
                <strong>Fone:</strong>
                &nbsp;{{ formatarTelefone(user.telefone_fixo) }}
                <br />
                <strong>Celular:</strong>
                &nbsp;{{ formatarTelefone(user.telefone_celular) }}
                <i v-if="user.telefone_celular_verificado === 1" class="fa-solid fa-check" style="margin-left: 7px; color: green"></i>

                <span style="margin-left: 45px; color: black" v-if="user.telefone_celular_verificado == 0">
                  <b>Código:&nbsp;</b>
                  <span>{{ user.telefone_celular_verificacao_code }}</span>
                </span>

                <span
                  @click="cadastro_selecionado = user"
                  data-toggle="modal"
                  data-target="#visualizar-celulares"
                  class="right badge badge-danger"
                  style="margin-left: 15px; background-color: blue"
                  v-if="user.celulares && user.celulares.length > 0"
                >
                  Existe
                </span>
                <br />
                <strong>IP de cadastro:</strong>
                &nbsp;{{ user.cadastro_ip }}
                <span
                  @click="cadastro_selecionado = user"
                  data-toggle="modal"
                  data-target="#visualizar-ips"
                  class="right badge badge-danger"
                  style="margin-left: 15px; background-color: blue"
                  v-if="user.ips && user.ips.length > 0"
                >
                  Existe
                </span>
                <br />
                <br />
                <div class="card" style="max-width: 450px; background-color: rgb(219, 181, 10) !important" v-if="user.pendencias.length">
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation" style="margin-right: 2px"></i>
                    <b>Possui pendências, verificar:</b>
                    <br />
                    <p v-for="(pendencia, index) in user.pendencias" :key="pendencia">
                      <span>Data: {{ formatDate(pendencia.created_at) }}</span>
                      <br />
                      <span v-html="pendencia.conteudo"></span>
                    </p>
                  </div>
                </div>
                <div class="card" style="max-width: 450px; background-color: #916244 !important" v-if="user.observacoes">
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation" style="margin-right: 2px"></i>
                    <b>Anotações internas:</b>
                    <br />
                    <span>{{ user.observacoes }}</span>
                  </div>
                </div>
              </td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a @click="getUrlDetalhes(user)" class="dropdown-item">
                    <i class="fa-solid fa-pen"></i>
                    &nbsp;&nbsp; Editar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a :href="'/admin/cadastros/' + user.id + '/logs'" class="dropdown-item">
                    <i class="fa-solid fa-bars"></i>
                    &nbsp;&nbsp; Logs
                  </a>

                  <div class="dropdown-divider"></div>
                  <a href="#" @click="validarExcluirCadastro(user)" class="dropdown-item">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Excluir
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div class="dropdown-divider"></div>
          <a @click="getUrlDetalhes(cadastro_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-pen"></i>
            &nbsp;&nbsp; Editar
          </a>

          <div class="dropdown-divider"></div>
          <a :href="'/admin/cadastros/' + cadastro_selecionado.id + '/logs'" class="dropdown-item">
            <i class="fa-solid fa-bars"></i>
            &nbsp;&nbsp; Logs
          </a>
        </div>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + users.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>

  <!-- MODAL IPS -->
  <div class="modal fade" id="visualizar-ips" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="margin-top: 30px">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Ocorrências</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in cadastro_selecionado.ips" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL CELULARES -->
  <div
    class="modal fade"
    id="visualizar-celulares"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Ocorrências</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in cadastro_selecionado.celulares" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL CPFS -->
  <div class="modal fade" id="visualizar-cpfs" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="margin-top: 30px">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Ocorrências</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in cadastro_selecionado.cpfs" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import auxFormatacao from "../../controller/auxFormatacao";

export default {
  props: ["estados", "cidades"],

  mixins: [sweetAlert, Swal, AuxController, auxFormatacao],

  components: [Loading],

  data() {
    return {
      id: "",
      isLoading: false,
      user_selecionado: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      users: [],
      cidades: [],
      estado: "",
      cidade: "",
      local: "EXCLUSIVAMENTE ONLINE",
      cpf: "",
      cnpj: "",
      telefone: "",
      email: "",
      teste: 0,
      executado: "",
      processo: "",
      termo: "",
      cadastro_tipo: "",
      apelido: "",
      estado_civil: "",
      status_usuario: "",
      cadastro_selecionado: "",
      nome: "",
      somente_magistrados: "",
      max_page: 0,
      endereco: "",
      telefone_fixo: "",
    };
  },

  /*
  created() {
    console.log(this.docs_tipo_usuario);

    this.buscarUsuarios(true);

    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.pagina_atual = Number(page);
    }
  },
  */

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.buscarUsuarios(true);

    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.pagina_atual = Number(page);
    }
  },

  methods: {
    validarExcluirCadastro(user) {
      console.log("V1");
      console.log(user);

      this.user_selecionado = user;

      let data = {
        id: this.user_selecionado.user_id,
      };

      console.log("Validando");
      console.log(data);

      axios
        .post(`/admin/delete_user/validate`, data)
        .then((response) => {
          console.log("Resposta");
          console.log(response);

          if (response.data.success) {
            let html = "Deseja apagar o usuário com o e-mail " + user.email + " e com apelido " + user.apelido + " ? Essa ação é irreversível.";

            this.$swal
              .fire({
                title: "Confirmação",
                html: html,
                icon: "warning",
                padding: "1.5em",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, quero deletar!",
              })
              .then((result) => {
                if (result.value) {
                  this.isLoading = true;

                  let data = {
                    id: this.user_selecionado.user_id,
                    pergunta: html,
                  };

                  axios
                    .post(`/admin/delete_user/delete`, data)
                    .then((response) => {
                      this.showSuccessMessage("Usuário deletado com sucesso!");
                      this.buscarUsuarios();
                    })
                    .catch((error) => {
                      this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                      console.log(error.response.data);
                    });
                }
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = this.formatToCompare(new Date());
        let data = this.formatToCompare(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, cadastro) {
      this.cadastro_selecionado = cadastro;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 600;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 500 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    getClass(user) {
      if (user.status == "pendente") {
        return "table_todos_line";
      } else if (user.status == "liberado") {
        return "table_todos_line";
      } else if (user.status == "bloqueado") {
        return "table_todos_line";
      } else {
        return "";
      }
    },

    getStyle(user) {
      let style = "cursor:pointer;";

      if (user.status == "pendente") {
        return style + "background-color: #fcfdcd";
      } else if (user.status == "liberado") {
        return style + "background-color: #d6fbe4";
      } else if (user.status == "bloqueado") {
        return style + "background-color: #ffdbdb";
      } else {
        return style;
      }
    },

    getUrlDetalhes(user) {
      window.location.href = "/admin/cadastros/detalhes/" + user.user_id;
    },

    changeStatus(user, atual) {
      console.log(user);

      let data = {
        user_id: user.id,
        user_oculto: this.convertToTiny(user.user_oculto),
        user_retirado: this.convertToTiny(user.user_retirado),
        user_encerrado: this.convertToTiny(user.user_encerrado),
        user_suspenso: this.convertToTiny(user.user_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/user/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    handler() {
      alert("Right!");
    },

    getUrlDocumentos(user) {
      return "/admin/documentos/" + user.id + "";
    },

    getUrlListarLotes(user) {
      return "/admin/user/" + user.id + "/lotes";
    },

    getUrlAddLote(user) {
      return "/admin/user/" + user.id + "/lotes/cadastrar_lote";
    },

    limparFiltros() {
      this.id = "";
      this.estado = "";
      this.cidade = "";
      this.comitente = "";
      this.titulo = "";
      this.descricao = "";
      this.local = "EXCLUSIVAMENTE ONLINE";
      this.tipo = "";
      this.teste = 0;
      this.executado = "";
      this.processo = "";
      this.termo = "";
      this.cadastro_tipo = "";
      this.apelido = "";
      this.telefone = "";
      this.estado_civil = "";
      this.status_usuario = "";
      this.email = "";
      this.cpf = "";
      this.cnpj = "";
      this.id = "";
      this.endereco = "";
      this.nome = "";
      this.telefone_fixo = "";
      this.somente_magistrados = false;

      this.pagina_atual = 1;
      window.history.replaceState(null, null, "?page=1");

      this.buscarUsuarios();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();

        let tempo = " dias";
        if (days < 2) {
          tempo = " dia";
        }

        return ~~days + tempo;
      } else {
        let tempo = " horas";
        if (hours < 2) {
          tempo = " hora";
        }

        return ~~hours + tempo;
      }
    },

    visualizar(user) {
      this.user_selecionado = user;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(user) {
      return "/admin/user/" + user.id;
    },

    show(user) {
      this.user_selecionado = user;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + pagina);

        this.buscarUsuarios(true);
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + this.max_page);

        this.buscarUsuarios(true);
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          //this.buscarUsuarios();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarUsuarios(manter_inicio) {
      if (!manter_inicio || manter_inicio == null) {
        this.inicio = 0;
        this.pagina_atual = 1;
        window.history.replaceState(null, null, "?page=1");
      }

      console.log("Atual");
      console.log(this.pagina_atual);

      this.isLoading = true;

      let data = {
        cpf: this.cpf,
        cnpj: this.cnpj,
        telefone: this.telefone,
        email: this.email,
        cadastro_tipo: this.cadastro_tipo,
        termo: this.termo,
        estado: this.estado,
        cidade: this.cidade,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        apelido: this.apelido,
        estado_civil: this.estado_civil,
        status_usuario: this.status_usuario,
        nome: this.nome,
        id: this.id,
        somente_magistrados: this.somente_magistrados,
        endereco: this.endereco,
        razao_social: this.razao_social,
        telefone_fixo: this.telefone_fixo,
      };

      console.log(data);

      axios
        .post(`/admin/cadastros/todos/search`, data)
        .then((response) => {
          this.users = response.data.users;
          this.total = response.data.total;

          console.log("USUÁRIOS");
          console.log(this.users);

          //console.log("PENDENCIA");
          //console.log(this.users[0].pendencias);

          this.pagination(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarUsuarios(true);
    },

    deletar(user) {
      this.user_selecionado = user;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de user<b><br/>" + this.user_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.user_selecionado.id,
            };

            axios
              .post(`/admin/user/delete`, data)
              .then((response) => {
                this.showSuccessMessage("user deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.user_selecionado.id,
        cadastro_tipo: this.user_selecionado.cadastro_tipo,
        tipodoc: this.user_selecionado.tipodoc,
        estado_civil: this.user_selecionado.estado_civil,
        obrigatorio: this.user_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
